<template>
  <div class="tabs">
    <div
      class="selector"
      :style="
        currentElement
          ? `left: ${currentElement.offsetLeft}px ; width: ${currentElement.clientWidth}px;`
          : ''
      "
    ></div>
    <Tab
      v-for="tab in tabs"
      :key="tab.value"
      :tab="tab"
      @click="handleTabClick(tab, $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import Tab from "./Tab.vue"
import { TabType } from "./types"
export default defineComponent({
  name: "TabsComponent",
  props: {
    tabs: {
      type: Array as PropType<TabType<string | number>[]>,
      required: true,
    },
  },
  data() {
    return {
      currentElement: null as unknown as Element,
    }
  },
  components: { Tab },
  methods: {
    handleTabClick(tab: TabType<string | number>, event: MouseEvent) {
      this.tabs.forEach((tabItem) => (tabItem.active = false))
      tab.active = true
      this.$emit("change", tab)
      this.currentElement = event.target as Element
    },
  },
})
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
  position: relative;
  gap: 4px;
  min-height: max-content;
  height: 32px;
  background: rgba(9, 13, 20, 0.24);
  border-radius: 12px;

  .selector {
    display: flex;
    align-items: center;
    position: absolute;
    height: 28px;
    left: 0px;
    top: 2px;
    z-index: 1;
    border-radius: 8px;
    transition-duration: 0.6s;
    transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
    background: var(--text-gradient);
    font-weight: 600;
    line-height: 20px;
    color: #ffffff;
  }
}
</style>
